import React, { useEffect, useState } from 'react';
import { BASE_URL } from '../config/api';
import { useNavigate } from 'react-router-dom';
import jsPDF from 'jspdf'; // Import jsPDF
import 'jspdf-autotable'; // Import jsPDF autoTable plugin

const HolidaysList = () => {
    const [holidays, setHolidays] = useState([]);
    const [filteredHolidays, setFilteredHolidays] = useState([]);
    const [searchTerm, setSearchTerm] = useState('');
    const navigate = useNavigate();

    useEffect(() => {
        fetch(`${BASE_URL}holidays`)
            .then((response) => response.json())
            .then((data) => {
                if (data.status === 1) {
                    setHolidays(data.data);
                    setFilteredHolidays(data.data);
                } else {
                    alert('Failed to fetch holidays.');
                }
            })
            .catch((error) => console.error('Error fetching holidays:', error));
    }, []);

    const handleSearchChange = (event) => {
        const term = event.target.value;
        setSearchTerm(term);
        const filtered = holidays.filter((holiday) =>
            holiday.name.toLowerCase().includes(term.toLowerCase())
        );
        setFilteredHolidays(filtered);
    };

    const handleAdd = () => {
        navigate('/AddHoliday');
    };

    const handleEdit = (id) => {
        navigate(`/EditHoliday/${id}`);
    };

    const handleDelete = (id) => {
        if (window.confirm('Are you sure you want to delete this holiday?')) {
            fetch(`${BASE_URL}holidays/${id}`, {
                method: 'DELETE',
                headers: {
                    'Content-Type': 'application/json',
                },
            })
                .then((response) => response.json())
                .then((data) => {
                    if (data.status === 1) {
                        setHolidays(holidays.filter((holiday) => holiday.id !== id));
                        setFilteredHolidays(
                            filteredHolidays.filter((holiday) => holiday.id !== id)
                        );
                        alert('Holiday deleted successfully!');
                    } else {
                        alert('Error deleting holiday. Please try again.');
                    }
                })
                .catch((error) => console.error('Error deleting holiday:', error));
        }
    };

    const handleExportPDF = () => {
        const doc = new jsPDF();
        doc.setFontSize(16);
        doc.text('Holidays List', 14, 20);

        const tableColumn = ['Name', 'Date'];
        const tableRows = [];

        filteredHolidays.forEach((holiday) => {
            const holidayData = [
                holiday.name || 'N/A',
                new Date(holiday.date).toLocaleDateString() +
                    ' ' +
                    new Date(holiday.date).toLocaleTimeString(),
            ];
            tableRows.push(holidayData);
        });

        doc.autoTable({
            head: [tableColumn],
            body: tableRows,
            startY: 30,
        });

        doc.save('holidays-list.pdf');
    };

    return (
        <div id="main">
            <header className="mb-3">
                <a href="#" className="burger-btn d-block d-xl-none">
                    <i className="bi bi-justify fs-3"></i>
                </a>
            </header>

            <div className="page-heading">
                <div className="page-title">
                    <div className="row">
                        <div className="col-12 col-md-6 order-md-1 order-last">
                            <h3>Holiday List</h3>
                        </div>
                        <div className="col-12 col-md-6 order-md-2 order-first">
                            <nav
                                aria-label="breadcrumb"
                                className="breadcrumb-header float-start float-lg-end"
                            >
                                <ol className="breadcrumb"></ol>
                            </nav>
                        </div>
                    </div>
                </div>
            </div>

            <section className="section">
                <div className="row" id="basic-table">
                    <div className="col-12 col-md-12">
                        <div className="card">
                            <div className="card-header">
                                <div className="row">
                                    <div className="col-md-6">
                                        <button
                                            className="btn btn-secondary"
                                            onClick={handleExportPDF}
                                        >
                                            Export to PDF
                                        </button>
                                    </div>
                                    <div className="col-md-6 text-end">
                                        <button
                                            className="btn btn-primary"
                                            onClick={handleAdd}
                                        >
                                            Add Holiday
                                        </button>
                                    </div>
                                </div>
                            </div>
                            <div className="card-body">
                                <div className="mb-3">
                                    <label htmlFor="searchTerm" className="form-label">
                                        Search by Name
                                    </label>
                                    <input
                                        type="text"
                                        id="searchTerm"
                                        className="form-control"
                                        placeholder="Search holiday name"
                                        value={searchTerm}
                                        onChange={handleSearchChange}
                                    />
                                </div>
                                <div className="table-responsive">
                                    <table className="table table-lg">
                                        <thead>
                                            <tr>
                                                <th>NAME</th>
                                                <th>DATE</th>
                                                <th className="text-end">ACTION</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {filteredHolidays.length > 0 ? (
                                                filteredHolidays.map((holiday) => (
                                                    <tr key={holiday.id}>
                                                        <td>{holiday.name || 'N/A'}</td>
                                                        <td>
                                                            {new Date(
                                                                holiday.date
                                                            ).toLocaleDateString()}{' '}
                                                            {new Date(
                                                                holiday.date
                                                            ).toLocaleTimeString()}
                                                        </td>
                                                        <td className="text-end">
                                                            <button
                                                                className="btn btn-success"
                                                                onClick={() =>
                                                                    handleEdit(holiday.id)
                                                                }
                                                            >
                                                                Edit
                                                            </button>
                                                            <button
                                                                className="btn btn-danger ms-2"
                                                                onClick={() =>
                                                                    handleDelete(holiday.id)
                                                                }
                                                            >
                                                                Delete
                                                            </button>
                                                        </td>
                                                    </tr>
                                                ))
                                            ) : (
                                                <tr>
                                                    <td colSpan="3" className="text-center">
                                                        No holidays available
                                                    </td>
                                                </tr>
                                            )}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
};

export default HolidaysList;
